export function telRule(rule, value, callback) {
  if (!value) {
    callback(new Error("请填写" + rule.words));
  } else {
    let str = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/
    let r = new RegExp(str)
    if (r.test(value)) {
        callback();
    }
    else {
      callback(new Error("请填写正确的" + rule.words));
    }
  }
}
export function numberRule(rule, value, callback) {
  if (!value) {
    callback(new Error("请填写" + rule.words));
  } else {
    let str = "^(-?\\d+)(\\.[0-9]{0," + rule.precision + "})?$";
    let r = new RegExp(str)
    if (r.test(value)) {
      if ((rule.max!==null || rule.max!==undefined) && value > rule.max ) {
        callback(new Error(`请填写小于` + rule.max + `的数字`));
      }
      else if ((rule.min!==null || rule.min!==undefined) && value < rule.min) {
        callback(new Error(`请填写大于` + rule.min + `的数字`));
      }
      else {
        callback();
      }
    }
    else {
      if (rule.precision) {
        callback(new Error("请填写" + rule.precision + "位小数以内的数字"));
      }
      else {
        callback(new Error("请填写整数数字"));
      }
    }

  }
}